import { httpAI, httpV2 } from "../http.js";

const ChatbotService = {
  composeLog: (accountId, user_id, question) =>
    httpAI.post("/compose", {
      accountId,
      user_id,
      question,
    }),

  // FAQ endpoints
  listFaqs: (
    search = "",
    sort_by = "updated_at",
    sort_order = "desc",
    page = 0,
    per_page = 20,
  ) =>
    httpAI.get(
      `/faq?search=${search}&sort_by=${sort_by}&sort_order=${sort_order}&page=${page}&per_page=${per_page}`,
    ),

  listTemplates: () => httpAI.get(`/faq/templates`),

  createFaq: (faq) => httpAI.post("/faq", faq),

  updateFaq: (id, faq) => httpAI.put(`/faq/${id}`, faq),

  deleteFaq: (id) => httpAI.delete(`/faq/${id}`),

  removeTemplate: (id) => httpAI.delete(`/faq/template/${id}`),

  getFaqLogs: (id) => httpAI.get(`/chatbot/${id}/logs`),

  listUnansweredQuestions: (
    filter = "unresolved",
    search = "",
    page = 0,
    per_page = 20,
  ) =>
    httpAI.get(
      `/logs/unanswered?filter=${filter}&search=${search}&page=${page}&per_page=${per_page}`,
    ),

  deleteUnansweredQuestion: (id) => httpAI.delete(`/logs/unanswered/${id}`),

  resolve: (id, question, answer) =>
    httpAI.post(`/logs/unanswered/${id}/resolve`, { answer, question }),
};

export default ChatbotService;
